module.exports = __webpack_public_path__ + "static/card-open-3867b5d9a20c43b253074d9eaefa523c.jpg";